import { Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Price } from '@app/core/business/price';
import { Product } from '@app/core/business/product/product';
import { ContextService } from '@app/core/service/context.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PriceListType } from '@app/core/business/price-list-type.enum';
import { OfferStateService } from '@app/ui/offer/offer-state.service';

@UntilDestroy()
@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PriceComponent implements OnInit, OnChanges, OnDestroy {
  public get isFruitsSecs(): boolean {
    if (!this.product) return false;

    // Le champ groupment existe dynamiquement
    const groupement = (this.product as any)['groupment'] || (this.product as any)['Groupment'];

    if (groupement) {
      if (Array.isArray(groupement)) {
        return groupement.some(g => typeof g === 'string' && g.toLowerCase().includes('fruits secs'));
      }
      
      if (typeof groupement === 'string' && groupement.toLowerCase().includes('fruits secs')) {
        return true;
      }
    }

    // console.log("IsFruitsSecs:False", this.product);

    return false;
  }

  @Input()
  priceTypeField = PriceListType.Net;
  @Input()
  product: Product;
  @Input()
  displayHelp = false;
  @Input()
  displayMoreHelp = false;

  public currentPrice: Price;
  public quantity = 0;
  public priceWithDiscounts = false;

  constructor(private contextService: ContextService, public offerState: OfferStateService) { }

  ngOnInit(): void {
    this.contextService.fullContext$
      .pipe(untilDestroyed(this))
      .subscribe(fullContext => {
        if (fullContext.order) {
          // Find order line for product
          const line = fullContext.order.lines.find(
            l => l.productCode === this.product.code
          );
          // If order line exist, set quantity, else set it to 0
          this.quantity = line ? line.quantity : 0;
          this.ngOnChanges();
        }
      });
  }

  ngOnDestroy(): void { }

  ngOnChanges(changes?: SimpleChanges): void {
    // Update current price when quantity change
    if (this.product && this.product.price) {
      const priceRange = this.product?.price?.find(
        range =>
          this.quantity >= parseInt(range.minQuantity, 10) && // If it is more than the minimum
          (range.maxQuantity
            ? this.quantity <= parseInt(range.maxQuantity, 10) // If max quantity exist, check if it is under,
            : true)
      );

      if (!priceRange && this.product && this.product?.price[0]) {
        //PRONATURA : Affichage du premier prix - VITAFRAIS : Affichage du deuxième prix s'il y en a un
        if (this.contextService.fullContext.company?.code == 'VITAFRAIS' && this.product.price[1])
          this.currentPrice = this.product?.price[1]?.price;
        else
          this.currentPrice = this.product?.price[0]?.price;
      }
      else {
        if (priceRange)
          this.currentPrice = priceRange.price;
        else
          // Pas de prix / pas d'informations
          this.displayHelp = false;
      }
      if (this.currentPrice && this.priceTypeField === 'net' && !this.currentPrice.net && this.currentPrice.gross) {
        // Si pas de net disponible, on bascule sur le brut
        this.priceTypeField = PriceListType.Gross;
      }
      if (this.product && this.product.price[0]) {
        //Pour VITAFRAIS, vérification s'il y a des remises
        if (this.contextService.fullContext.company?.code == 'VITAFRAIS' && this.product.price[0]?.price?.discountsPercentage?.length > 0)
          this.priceWithDiscounts = true
        else
          this.priceWithDiscounts = false;
      }
    }

  }

  public parseFloat(value: string): number {

    if (value) {
      value = value.replace(',', '.');
      return parseFloat(value);
    }
    else {
      return undefined;
    }

  }
}
